<template>
  <el-form ref="form" :model="formData" size="mini">
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="同步结果确认状态">
          <el-input v-model="formData.v_syncStatus" readonly> </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="接收时间">
          <el-input
            v-model="formData.receiveTime"
            readonly
            prefix-icon="el-icon-date"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="同步的订单数据">
          <el-input
            v-model="formData.syncOrderData"
            type="textarea"
            rows="5"
            readonly
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="同步时间">
          <el-input
            v-model="formData.syncTime"
            readonly
            prefix-icon="el-icon-date"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="同步结果">
          <el-input
            v-model="formData.syncResult"
            type="textarea"
            rows="5"
            readonly
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    formData: {type: Object, default: () => {}},
    disabled: {type: Boolean, default: false},
  },
}
</script>
